import { useApiGet } from '../api/apiHooks'
import { getStandingsUrl } from '../api/urls'
import TableSkeleton from '../Component/SkeletonLoaders/TableSkeleton'
import { logoMap } from '../data-maps/club-logo-map'
import PropTypes from 'prop-types'

function Standings({ leagueIdOrIdentity, seasonName }) {
  const {
    data: standingsData,
    isLoading: isApiLoading,
    isError,
    error,
  } = useApiGet({
    queryKey: [getStandingsUrl(seasonName, leagueIdOrIdentity)],
    refetchInterval: 300000, // refetches every
  })

  let sortedStandingData = standingsData?.sort(
    (a, b) => a.position - b.position
  )

  if (isApiLoading) return <TableSkeleton rows={20} columns={1} height={40} />
  if (isError)
    return (
      <p style={{ color: 'red' }}>
        {error.message || 'Error loading standings'} data.
      </p>
    )

  return (
    <>
      <div
        className='table_container'
        style={{ width: 'clamp(300px, 95vw, 800px)' }}
      >
        <table className='transaction_tbl'>
          <thead>
            <tr>
              <th>#</th>
              <th>Club</th>
              <th>Points</th>
            </tr>
          </thead>
          <tbody>
            {sortedStandingData?.map((team) => (
              <tr key={team.id}>
                <td>{team.position}</td>
                <td style={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={
                      logoMap[team.participant.id] ||
                      team.participant.image_path
                    }
                    alt={team.participant.name}
                    style={{ height: 35, width: 35, marginRight: 10 }}
                  />
                  {team.participant.name}
                </td>
                <td>{team.points}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}

export default Standings

// prop validation
Standings.propTypes = {
  leagueIdOrIdentity: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  seasonName: PropTypes.string.isRequired,
}
